import { Box, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Locais from './Locais'
import { motion } from "framer-motion";

import sede_social from '../../../images/sede_social.webp'
import sede_campestre from '../../../images/sede_campestre.webp'

const Categorias = ({ allPlaces }) => {

    const [selecionaCategoria, setSelecionaCategoria] = useState(null)

    const handleCategoryClick = (categoria) => {
        setSelecionaCategoria(categoria); // Atualiza o estado com a categoria clicada
    };

    useEffect(() => {
        setSelecionaCategoria(allPlaces[0].categoria)

    }, [allPlaces])

    return (
        <>
            <Grid container item xs={12} md={12}>

                {/* imagem */}
                <Grid item xs={12} md={4} sx={{ mb: 2 }}>
                    <motion.img
                        key={selecionaCategoria} // Importante para garantir que o Framer Motion detecte a mudança
                        src={selecionaCategoria?.toUpperCase().includes("SOCIAL") ? sede_social : sede_campestre} alt="Imagem Ascoprel"
                        style={{
                            width: "100%", height: "100%",
                            objectFit: "cover", borderRadius: "20px",
                            border: "3px solid #411D73",
                        }}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                    />
                </Grid>

                {/* categoria */}
                <Grid item xs={12} md={4} sx={{
                    display: "flex",
                    justifyContent: 'space-between',
                    flexDirection: { xs: "row", md: "column" },
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "wrap",
                    mb: 2
                }}>
                    {allPlaces && allPlaces.map((item) => (
                        <Chip key={item.id} label={
                            <Typography sx={{ textAlign: "center", whiteSpace: "pre-line", fontWeight: 'bold', fontSize:'18px' }}>
                                {item.categoria.split(" ").join("\n")}
                            </Typography>
                        }
                            onClick={() => handleCategoryClick(item.categoria)}
                            sx={{
                                ...(selecionaCategoria === item.categoria ? sxCategorySelected : sxCategoryDefault),
                                ...sxCategoryBase
                            }} />
                    ))}
                </Grid>

                {/* locais */}
                <Locais allPlaces={allPlaces} selecionaCategoria={selecionaCategoria} />

            </Grid>
        </>
    )
}

export default Categorias

export const OpcoesLocais = styled(Box)(() => ({
    background: "#787878",
    border: '5%',
    width: 120,
}))

const sxCategoryDefault = {
    color: '#141259',
};

const sxCategorySelected = {
    border: '3px solid #141259',
    color: '#141259'
};

const sxCategoryBase = {
    width: 140,
    height: 140,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
    backgroundColor: '#f2f2f2'
}